import CommunityBasePage from './Community';

export default CommunityBasePage;
